// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SnHc","icon":"styles_icon__2SkL5"};